/** 后台登录 */
// export const agentLoginApiUri = '/agent/login';


// 登录
export const loginApiUri = '/oauth2/login';


// /statistics/index  首页数据
export const homeDateUri = '/admin/statistics/index';

// /agent/menu/get/  layout 列表
export const menuUri = '/admin/menu/list';

// /restful/admin/merchant/list  商户列表
export const merchantListUri = '/admin/merchant/list';

// /restful/admin/merchant/create  添加商户
export const createMerchantUri = '/admin/merchant/create';

// /restful/admin/merchant/update  修改商户
export const updateMerchantUri = '/admin/merchant/update';

// /restful/admin/merchant/whitelist  获取白名单列表
export const whitelistMerchantUri = '/admin/merchant/whitelist';

// /restful/admin/merchant/setWhitelist    设置白名单
export const setWhitelistMerchantUri = '/admin/merchant/setPhoneList';

// admin/order/getOrderListBySearch     订单列表
export const getOrderListBySearchUri = '/admin/order/getOrderListBySearch';

// admin/order/getOrderStatusList     订单状态列表
export const getOrderStatusListUri = '/admin/order/getOrderStatusList';

// /restful/admin/cabinet/list    机柜列表
export const getCabinetListBySearchUri = '/admin/cabinet/list';

// /restful/admin/cabinet/slots  查看插槽
export const getCabinetSlotsUri = '/admin/cabinet/slots';

// /restful/admin/merchant/simpleList  简单列表  /restful/admin/merchant/simpleList
export const getSimpleMerchantListUri = '/admin/merchant/simpleList';

// /restful/admin/plan/list  套餐列表
export const getPlanListUri = '/admin/plan/list';

// /restful/admin/cabinet/force-pop
export const forcePopCabinetUri = '/admin/cabinet/force-pop';

// /restful/admin/plan/simpleList
export const getSimplePlanListUri = '/admin/plan/simpleList';

// /restful/admin/cabinet/update
export const updateCabinetUri = '/admin/cabinet/update';

// /restful/admin/plan/update
export const updatePlanUri = '/admin/plan/update';

// /restful/admin/player/list
export const getPlayerListUri = '/admin/player/list';



// /restful/admin/merchant/phoneList  白名单 黑名单列表
export const getPhoneListUri = '/admin/merchant/phoneList';


// admin/order/refund
export const refundOrderUri = '/admin/order/refund';

// /restful/admin/cabinet/slot/updateDisabled
export const updateCabinetSlotDisabledUri = '/admin/cabinet/slot/updateDisabled';

// /restful/admin/plan/create
export const createPlanUri = '/admin/plan/create';

// /restful/admin/cabinet/unbind-merchant
export const unbindMerchantUri = '/admin/cabinet/unbindMerchant';

// /restful/admin/player/update
export const updatePlayerUri = '/admin/player/update';

// /restful/admin/statistics/merchant
export const getStatisticsMerchantUri = '/admin/statistics/merchant';

// /restful/admin/cabinet/check
export const checkCabinetUri = '/admin/cabinet/check';

// /restful/admin/order/complete
export const completeOrderUri = '/admin/order/complete';

// admin/command/list
export const commandListUri = '/admin/command/list';

// admin/cabinet/updateCommandList
export const updateCommandListUri = '/admin/cabinet/updateCommandList';

// admin/version/list
export const versionListUri = '/admin/version/list';

// admin/version/updateVersionAndCommandListRelation
export const updateVersionAndCommandListRelationUri = '/admin/version/updateVersionAndCommandListRelation';

// admin/device/sendCommandForDevice
export const sendCommandForDeviceUri = '/admin/device/sendCommandForDevice';